var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalStudioLicenses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.63637 11.2273V13.8182H11.2273V16.4091H13.8182V18.1364L15.5455 19.8636H19.8636V16.4091L11.0027 7.54819C11.1496 7.07319 11.2273 6.56365 11.2273 6.04547C11.2273 3.18683 8.9041 0.863647 6.04547 0.863647C3.18683 0.863647 0.863647 3.18683 0.863647 6.04547C0.863647 8.9041 3.18683 11.2273 6.04547 11.2273C6.80547 11.2273 7.53092 11.0632 8.17865 10.7696L8.63637 11.2273ZM5.18183 6.04547C4.70467 6.04547 4.31819 5.65899 4.31819 5.18183C4.31819 4.70467 4.70467 4.31819 5.18183 4.31819C5.65899 4.31819 6.04547 4.70467 6.04547 5.18183C6.04547 5.65899 5.65899 6.04547 5.18183 6.04547Z",
    stroke: "white",
    strokeWidth: 1.72727
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalStudioLicenses);
export default __webpack_public_path__ + "static/media/total_studio_licenses.20682855dd8e2dd89194fedc9128500d.svg";
export { ForwardRef as ReactComponent };